export const PENDING_ISSUE_STABLECOIN = "PENDING_ISSUE_STABLECOIN";
export const REQUEST_ISSUE_STABLECOIN = "REQUEST_ISSUE_STABLECOIN";
export const RESPONSE_ISSUE_STABLECOIN = "RESPONSE_ISSUE_STABLECOIN";
export const RESET_ISSUE_STABLECOIN = "RESET_ISSUE_STABLECOIN";
